import React, { type FC } from 'react';
import { FormLabel, FormLabelProps } from '../FormLabel';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormLabel: FC<FormLabelProps> = (props) => {
  const context = useAppFormControlContext();
  return (
    <FormLabel
      {...props}
      htmlFor={props.htmlFor ?? (context.name ? `${context.name}-input` : undefined)}
      required={props.required ?? context.required}
      error={'error' in props ? props.error : !!context.error}
      dataTest={appFormDataTestFactory(props.dataTest ?? context.dataTest).label}
      shrink
    />
  );
};
